import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { LabelText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ScreenHeaderEyebrow = (props: Props) => {
  const { children, style, ...restProps } = props;

  return (
    <LabelText
      maxFontSizeMultiplier={1.2}
      numberOfLines={1}
      sizeMatch={['10']}
      style={[styles.eyebrow, style]}
      {...restProps}
    >
      {children}
    </LabelText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  eyebrow: {
    textTransform: 'uppercase',
    color: theme.colors.OPACITY.WHITE.DARKER,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  color?: string;
} & ComponentProps<typeof LabelText>;
